import * as React from "react";
import { FunctionComponent, useContext } from "react";
import {
  SliderItemProps,
  SliderItemOnInteractInnerProps,
  SliderItemStatusType,
} from "./interfaces";
import {
  Block,
  Icon,
  Spacer,
  buttonType,
  IButtonProps,
  styled,
} from "../../../seenspire-library";
import { SliderItemButton, UnlockButtonStyles } from "./Styles";
import { SaveToChannelIcon } from "./SliderItemOnInteractLogic";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../state";
import { FeedType } from "seenspire-api-client";

const SliderUnlockButtonStyled = styled(SliderItemButton)<{
  customBackgroundColor: boolean;
}>`
  ${UnlockButtonStyles}
`;

const WithTrial = styled(SliderUnlockButtonStyled)<{ isTrial: boolean }>`
  background-color: ${({ isTrial }: any) => isTrial && "#03be06"};
  border: ${({ isTrial }: any) => isTrial && "1px solid #03be06"}!important;
  :hover {
    background-color: ${({ isTrial }: any) => isTrial && "#028f02"};
  }
`;

const SliderUnlockButton: FunctionComponent<SliderItemProps> = (props) => {
  const { channel } = props;
  const { t } = useTranslation();
  const {
    setRequestFeatureModalIsOpen,
    hasFeature,
    hasTrialStarted,
    hasTrialEnded,
    setRequestTrialModalIsOpen,
    account,
    client,
  } = useContext(AppContext);

  const featureToCheck = channel.type ? channel.type.slug as FeedType : "INFOTAINMENT";

  return (
    <WithTrial
      isTrial={true}
      customBackgroundColor={hasTrialStarted() && hasTrialStarted()}
      elementHeightBase={false}
      onClick={async () => {
        if (
          !hasFeature(featureToCheck) &&
          !hasTrialStarted() &&
          !hasTrialEnded()
        ) {
          const result = await client.Accounts.patchExtratrialAction(
            account.account.id.toString(),
            featureToCheck
          );
          setRequestTrialModalIsOpen(featureToCheck);
        }

        if (
          !hasFeature(featureToCheck) &&
          hasTrialStarted() &&
          hasTrialEnded()
        ) {
          setRequestFeatureModalIsOpen(featureToCheck);
        }
      }}
      elementWidth="block"
    >
      <Block flex="1" display="flex" justifyContent="space-between">
        <Block
          fontSize="smaller"
          textTransform="uppercase"
          textAlign="center"
          padding={{ left: 10 }}
        >
          {!hasTrialStarted() && !hasTrialStarted() ? (
            <span>Start your free trial</span>
          ) : (
            <span>Upgrade subscription</span>
          )}
        </Block>

        <Spacer />

        {hasTrialStarted() && hasTrialStarted() && (
          <SaveToChannelIcon status="INIT">
            {<Icon name="unlock" />}
          </SaveToChannelIcon>
        )}
      </Block>
    </WithTrial>
  );
};

export default SliderUnlockButton;
